import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7916a657"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dash-title" }
const _hoisted_2 = { class: "dash-sub-title" }
const _hoisted_3 = { class: "revenu-info" }
const _hoisted_4 = { class: "revenu-title" }
const _hoisted_5 = {
  key: 0,
  class: "big-title"
}
const _hoisted_6 = {
  key: 1,
  class: "revenu-title"
}
const _hoisted_7 = { class: "normal-txt" }
const _hoisted_8 = { class: "rise-txt" }
const _hoisted_9 = { class: "fall-txt" }
const _hoisted_10 = {
  key: 3,
  class: "revenu-title"
}
const _hoisted_11 = { class: "rise-txt" }
const _hoisted_12 = { class: "fall-txt" }
const _hoisted_13 = {
  key: 4,
  class: "big-title"
}
const _hoisted_14 = {
  key: 5,
  class: "revenu-title"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rise-txt" }, "0%", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rise-txt" }, "0%", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fall-txt" }, "0%", -1))
const _hoisted_18 = { class: "revenu-info" }
const _hoisted_19 = { class: "revenu-title" }
const _hoisted_20 = {
  key: 0,
  class: "big-title"
}
const _hoisted_21 = {
  key: 1,
  class: "revenu-title"
}
const _hoisted_22 = { class: "normal-txt" }
const _hoisted_23 = { class: "rise-txt" }
const _hoisted_24 = { class: "fall-txt" }
const _hoisted_25 = {
  key: 2,
  class: "big-title"
}
const _hoisted_26 = {
  key: 3,
  class: "revenu-title"
}
const _hoisted_27 = { class: "rise-txt" }
const _hoisted_28 = { class: "fall-txt" }
const _hoisted_29 = {
  key: 4,
  class: "big-title"
}
const _hoisted_30 = {
  key: 5,
  class: "revenu-title"
}
const _hoisted_31 = { class: "rise-txt" }
const _hoisted_32 = { class: "rise-txt" }
const _hoisted_33 = { class: "fall-txt" }
const _hoisted_34 = { class: "revenu-info" }
const _hoisted_35 = { class: "revenu-title" }
const _hoisted_36 = { class: "big-title" }
const _hoisted_37 = { class: "revenu-title" }
const _hoisted_38 = { class: "fall-txt" }
const _hoisted_39 = ["data-original-text"]
const _hoisted_40 = { class: "revenu-info" }
const _hoisted_41 = { class: "revenu-title" }
const _hoisted_42 = {
  key: 0,
  class: "big-title"
}
const _hoisted_43 = {
  key: 1,
  class: "revenu-title"
}
const _hoisted_44 = { class: "rise-txt" }
const _hoisted_45 = { class: "rise-txt" }
const _hoisted_46 = { class: "fall-txt" }
const _hoisted_47 = {
  key: 2,
  class: "big-title"
}
const _hoisted_48 = {
  key: 3,
  class: "revenu-title"
}
const _hoisted_49 = { class: "rise-txt" }
const _hoisted_50 = { class: "rise-txt" }
const _hoisted_51 = { class: "fall-txt" }
const _hoisted_52 = {
  key: 4,
  class: "big-title"
}
const _hoisted_53 = {
  key: 5,
  class: "revenu-title"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rise-txt" }, "0%", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rise-txt" }, "0%", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fall-txt" }, "0%", -1))
const _hoisted_57 = { class: "charts-title" }
const _hoisted_58 = { class: "charts-title" }
const _hoisted_59 = {
  key: 0,
  id: "donutChart",
  class: "donut-container"
}
const _hoisted_60 = { class: "warning-title" }
const _hoisted_61 = {
  key: 0,
  class: "warning-txt"
}
const _hoisted_62 = { style: {"padding":"8px"} }
const _hoisted_63 = { class: "charts-title" }
const _hoisted_64 = { style: {"padding":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_DollarCircleOutlined = _resolveComponent("DollarCircleOutlined")!
  const _component_RiseOutlined = _resolveComponent("RiseOutlined")!
  const _component_FallOutlined = _resolveComponent("FallOutlined")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ShoppingOutlined = _resolveComponent("ShoppingOutlined")!
  const _component_ShoppingCartOutlined = _resolveComponent("ShoppingCartOutlined")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_PercentageOutlined = _resolveComponent("PercentageOutlined")!
  const _component_SalesChart = _resolveComponent("SalesChart")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 16 },
          lg: { span: 16 },
          xl: { span: 16 },
          xxl: { span: 16 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_flex, {
              gap: "middle",
              vertical: "",
              align: "start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.t("Pos.Dashboard")), 1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.t("Pos.DahsboardTxt")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 4 },
          lg: { span: 4 },
          xl: { span: 4 },
          xxl: { span: 4 },
          class: "btn-dash-container"
        }, {
          default: _withCtx(() => [
            (_ctx.selectValue === 'monthly')
              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                  key: 0,
                  value: _ctx.monthlyPicker,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.monthlyPicker) = $event)),
                  picker: "month",
                  class: "calender-input",
                  "disabled-date": _ctx.disabledDate,
                  onChange: _ctx.handleMonthly
                }, null, 8, ["value", "disabled-date", "onChange"]))
              : _createCommentVNode("", true),
            (_ctx.selectValue === 'annual')
              ? (_openBlock(), _createBlock(_component_a_date_picker, {
                  key: 1,
                  value: _ctx.annualPicker,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.annualPicker) = $event)),
                  picker: "year",
                  class: "calender-input",
                  "disabled-date": _ctx.disabledDate,
                  onChange: _ctx.handleAnnual
                }, null, 8, ["value", "disabled-date", "onChange"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 4 },
          lg: { span: 4 },
          xl: { span: 4 },
          xxl: { span: 4 },
          class: "btn-dash-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.selectValue,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectValue) = $event)),
              "show-search": "",
              class: "select-calender",
              onChange: _ctx.handleChange
            }, {
              notFoundContent: _withCtx(() => [
                _createVNode(_component_a_empty, {
                  description: _ctx.t('Pos.NoData'),
                  image: _ctx.simpleImage
                }, null, 8, ["description", "image"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, {
                  value: "daily",
                  label: _ctx.t('Pos.daily')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.daily")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_select_option, {
                  value: "monthly",
                  label: _ctx.t('Pos.monthly')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.monthly")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_select_option, {
                  value: "annual",
                  label: _ctx.t('Pos.annual')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.annual")), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 12 },
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                _ctx.locale === 'ar' ? 'revenu-container-rtl' : 'revenu-container',
              ])
                      }, [
                        _createVNode(_component_DollarCircleOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t("Pos.Revenue")), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_flex, {
                  align: "start",
                  vertical: "",
                  class: "numbers-container"
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectValue === 'monthly' && _ctx.monthlyPicker !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatAmount(_ctx.state.monthlyRevenu)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'monthly' && _ctx.monthlyPicker !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          (_ctx.state.monthlyRevenuEff === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.state.monthlyRevenuEff), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.monthlyRevenuEff > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.monthlyRevenuEff)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.monthlyRevenuEff < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.monthlyRevenuEff)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'daily')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(["big-title", { 'is-rtl': _ctx.textDirection === 'rtl' }])
                        }, _toDisplayString(_ctx.formatAmount(_ctx.state.dailyRevenu)), 3))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'daily')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          (_ctx.state.dailyRevenuEffecency >= 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.dailyRevenuEffecency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.dailyRevenuEffecency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.dailyRevenuEffecency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'annual')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatAmount(_ctx.state.annualRevenue)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'annual')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          (_ctx.state.annualRevenuEffecency === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromLastYear")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.annualRevenuEffecency > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromLastYear")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.annualRevenuEffecency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _hoisted_17,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromLastYear")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 12 },
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                _ctx.locale === 'ar' ? 'order-container-rtl' : 'order-container',
              ])
                      }, [
                        _createVNode(_component_ShoppingOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t("Pos.TotalOrder")), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_flex, {
                  align: "start",
                  vertical: "",
                  class: "numbers-container"
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectValue === 'monthly' && _ctx.monthlyPicker !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.formatAmount(_ctx.state.monthlySales)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'monthly' && _ctx.monthlyPicker !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                          (_ctx.state.salesEfficiency === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.state.salesEfficiency), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.salesEfficiency > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.salesEfficiency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'daily')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.formatAmount(_ctx.state.todayTotalSales)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'daily')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                          (_ctx.state.salesEfficiency > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.salesEfficiency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'annual')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.formatAmount(_ctx.state.annualSales)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'annual')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                          (_ctx.state.salesEfficiency === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.salesEfficiency > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.salesEfficiency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.fixNumberVirgul(_ctx.state.salesEfficiency)) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 12 },
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                _ctx.locale === 'ar'
                  ? 'products-container-rtl'
                  : 'products-container',
              ])
                      }, [
                        _createVNode(_component_ShoppingCartOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.t("Pos.Products")), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_flex, {
                  align: "start",
                  vertical: "",
                  class: "numbers-container"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.state.totProducts) + " " + _toDisplayString(_ctx.t("Pos.Items")), 1),
                    _createElementVNode("span", _hoisted_37, [
                      _createVNode(_component_ExclamationCircleOutlined, {
                        class: _normalizeClass([_ctx.locale === 'ar' ? 'fall-icon-rtl' : 'fall-icon'])
                      }, null, 8, ["class"]),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.state.totProdOutOfStock), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass([_ctx.locale === 'ar' ? 'end-prod-txt-rtl' : 'end-prod-txt']),
                        "data-original-text": _ctx.t('Pos.Endofstockproducts')
                      }, _toDisplayString(_ctx.t("Pos.Endofstockproducts")), 11, _hoisted_39)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 12 },
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                _ctx.locale === 'ar'
                  ? 'discount-container-rtl'
                  : 'discount-container',
              ])
                      }, [
                        _createVNode(_component_PercentageOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.t("Pos.TotalDiscounts")), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_flex, {
                  align: "start",
                  vertical: "",
                  class: "numbers-container"
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectValue === 'monthly' && _ctx.monthlyPicker !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.formatAmount(_ctx.state.monthlyDiscount)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'monthly' && _ctx.monthlyPicker !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                          (_ctx.state.monthlyDiscountEff === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.state.monthlyDiscountEff) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.monthlyDiscountEff > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.state.monthlyDiscountEff) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.monthlyDiscountEff < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.state.monthlyDiscountEff) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.fromLastMonth")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'daily')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.formatAmount(_ctx.state.dailyDiscounts)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'daily')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                          (_ctx.state.dailyDiscountEffecency === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.state.dailyDiscountEffecency) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.dailyDiscountEffecency > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.state.dailyDiscountEffecency) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.dailyDiscountEffecency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.state.dailyDiscountEffecency) + "%", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromYesterday")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'annual')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.formatAmount(_ctx.state.annualDiscounts)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectValue === 'annual')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                          (_ctx.state.dailyDiscountEffecency === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _hoisted_54,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromLastYear")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.dailyDiscountEffecency > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_RiseOutlined, { class: "rise-icon" }),
                                _hoisted_55,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromLastYear")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.state.dailyDiscountEffecency < 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_FallOutlined, { class: "fall-icon" }),
                                _hoisted_56,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FromLastYear")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      class: "charts-container",
      gutter: 16
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 24 },
          lg: { span: 24 },
          xl: { span: 18 },
          xxl: { span: 18 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, { justify: "space-between" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.t("Pos.SalesOver")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SalesChart, {
                  data: _ctx.state.revenueData,
                  period: _ctx.selectValue
                }, null, 8, ["data", "period"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 24 },
          lg: { span: 24 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              hoverable: "",
              class: "donut-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  alig: "start",
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.t("Pos.PaymentMethod")), 1),
                    (_ctx.state.payements.length !== 0)
                      ? (_openBlock(), _createElementBlock("canvas", _hoisted_59))
                      : _createCommentVNode("", true),
                    (_ctx.state.payements.length === 0)
                      ? (_openBlock(), _createBlock(_component_a_empty, {
                          key: 1,
                          description: _ctx.t('Pos.NoData'),
                          image: _ctx.simpleImage
                        }, null, 8, ["description", "image"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      class: "charts-container",
      gutter: 24
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 24 },
          lg: { span: 24 },
          xl: { span: 24 },
          xxl: { span: 24 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: "tbl-title",
                  gutter: 16
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24 },
                      sm: { span: 24 },
                      md: { span: 16 },
                      lg: { span: 16 },
                      xl: { span: 16 },
                      xxl: { span: 16 },
                      class: "tbl-right"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ExclamationCircleOutlined, {
                          class: _normalizeClass([_ctx.locale === 'ar' ? 'warning-icon-rtl' : 'warning-icon'])
                        }, null, 8, ["class"]),
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.t("Pos.Endofstockproducts")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 24 },
                      sm: { span: 24 },
                      md: { span: 8 },
                      lg: { span: 8 },
                      xl: { span: 8 },
                      xxl: { span: 8 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.warehouse_id,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.warehouse_id) = $event)),
                          "show-search": "",
                          "option-filter-prop": 'label',
                          class: "select-input",
                          onChange: _ctx.handleWarehouseChange
                        }, {
                          notFoundContent: _withCtx(() => [
                            _createVNode(_component_a_empty, {
                              description: _ctx.t('Pos.NoData'),
                              image: _ctx.simpleImage
                            }, null, 8, ["description", "image"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.warehouses, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                label: item.name,
                                key: item.id,
                                value: item.id,
                                selected: item.id === _ctx.warehouse_id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value", "selected"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  columns: _ctx.endColumns,
                  "data-source": _ctx.state.endOfStock,
                  class: "table-container"
                }, {
                  emptyText: _withCtx(() => [
                    _createVNode(_component_a_empty, {
                      description: _ctx.t('Pos.NoData'),
                      image: _ctx.simpleImage
                    }, null, 8, ["description", "image"])
                  ]),
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'total')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(record.total), 1))
                      : _createCommentVNode("", true)
                  ]),
                  customFilterDropdown: _withCtx(({
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }) => [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_a_input, {
                        ref: "searchInput",
                        placeholder: `${column.title}`,
                        value: selectedKeys[0],
                        style: {"width":"188px","margin-bottom":"8px","display":"block"},
                        onChange: 
                  (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
                ,
                        onPressEnter: ($event: any) => (
                  _ctx.handleSearch(selectedKeys, confirm, column.dataIndex)
                )
                      }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "small",
                        style: {"width":"90px","margin-right":"8px"},
                        onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_SearchOutlined)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.Search")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"width":"90px"},
                        onClick: ($event: any) => (_ctx.handleReset(clearFilters))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("Pos.Reset")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  customFilterIcon: _withCtx(({ filtered }) => [
                    _createVNode(_component_search_outlined, {
                      style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
                    }, null, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["columns", "data-source"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { class: "popular-table" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24 },
          sm: { span: 24 },
          md: { span: 24 },
          lg: { span: 24 },
          xl: { span: 24 },
          xxl: { span: 24 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, { class: "tbl-title" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.t("Pos.PopularProducts")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  columns: _ctx.columns,
                  "data-source": _ctx.state.data,
                  class: "table-container"
                }, {
                  emptyText: _withCtx(() => [
                    _createVNode(_component_a_empty, {
                      description: _ctx.t('Pos.NoData'),
                      image: _ctx.simpleImage
                    }, null, 8, ["description", "image"])
                  ]),
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'total')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatTotal(record.total)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  customFilterDropdown: _withCtx(({
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }) => [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_a_input, {
                        ref: "searchInput",
                        placeholder: `${column.title}`,
                        value: selectedKeys[0],
                        style: {"width":"188px","margin-bottom":"8px","display":"block"},
                        onChange: 
                  (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
                ,
                        onPressEnter: ($event: any) => (
                  _ctx.handleSearch(selectedKeys, confirm, column.dataIndex)
                )
                      }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "small",
                        style: {"width":"90px","margin-right":"8px"},
                        onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_SearchOutlined)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.Search")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"width":"90px"},
                        onClick: ($event: any) => (_ctx.handleReset(clearFilters))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("Pos.Reset")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  customFilterIcon: _withCtx(({ filtered }) => [
                    _createVNode(_component_search_outlined, {
                      style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
                    }, null, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["columns", "data-source"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}